import { state, props } from 'cerebral/tags'
import { set } from 'cerebral/operators'

export default [
  set(
    state`media.uploading.${state`media.currentUpload.clientId`}.percentComplete`,
    props`progress`
  )
]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/onUploadProgress.js